import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import MusicOptions from '../1230/MusicOptions';
import SpiritualMusic from './SpiritualMusic';

export default class Spiritual1230 extends Component {
  /**************
   * Properties *
   **************/

  /**
   * The service's different screens
   */
  bannerVisible = {
    visible: false
  };
  selectReligious = {
    id: 'selectReligious',
    src: require('./images/spiritual/SelectReligious.png'),
    top: 453,
    left: 80,
    width: 417,
    height: 106
  };
  selectCategory = {
    id: 'selectCategory',
    src: require('./images/christian/SelectCategory.png'),
    top: 470,
    left: 103,
    width: 367,
    height: 67
  };
  selectListen = {
    id: 'selectCategory',
    src: require('./images/education/SelectListen.png'),
    top: 470,
    left: 103,
    width: 392,
    height: 68
  };
  nowPlayingGenesis = {
    id: 'nowPlayingGenesis',
    src: require('./images/oldtestament/NowPlaying_Genesis.png'),
    top: 426,
    left: 69,
    width: 422,
    height: 183
  };
  chapterPopup = {
    id: 'chapterPopup',
    src: require('./images/oldtestament/Chapter_Popup.png'),
    top: 0,
    left: 0
  };
  spiritualNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/main_menu'
  };
  christianNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/spiritual'
  };
  educationNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/spiritual/christian'
  };
  christianEducationNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/spiritual/christian/christian_education'
  };
  genesisNavigationBar = {
    mainMenu: false,
    back: false,
    backRoute: '/spiritual/christian/christian_education/old_testament'
  };
  musicButtons = [
    {
      id: 'christian',
      to: '/spiritual/christian',
      highlight: require('./images/spiritual/Spiritual_Christian_HL.png'),
      unhighlight: require('./images/spiritual/Spiritual_Christian_UH.png'),
      desc: require('./images/spiritual/Spiritual_Christian_desc.png'),
      alt: 'Christian'
    },
    {
      id: 'general',
      to: '/spiritual/general',
      highlight: require('./images/spiritual/Spiritual_General_HL.png'),
      unhighlight: require('./images/spiritual/Spiritual_General_UH.png'),
      desc: require('./images/spiritual/Spiritual_General_desc.png'),
      alt: 'General'
    },
    {
      id: 'islam',
      to: '/spiritual/islam',
      highlight: require('./images/spiritual/Spiritual_Islam_HL.png'),
      unhighlight: require('./images/spiritual/Spiritual_Islam_UH.png'),
      desc: require('./images/spiritual/Spiritual_Islam_desc.png'),
      alt: 'Islam'
    },
    {
      id: 'judaism',
      to: '/spiritual/judaism',
      highlight: require('./images/spiritual/Spiritual_Judaism_HL.png'),
      unhighlight: require('./images/spiritual/Spiritual_Judaism_UH.png'),
      desc: require('./images/spiritual/Spiritual_Judaism_desc.png'),
      alt: 'Judaism'
    }
  ];
  spiritualHeader = {
    id: 'header',
    src: require('./images/spiritual/1230_elements_Spiritual.png')
  };
  spiritualButtonList = {
    top: 75,
    left: 585
  };
  christianHeader = {
    id: 'header',
    src: require('./images/christian/1230_elements_Spiritual_Christian.png')
  };
  oldTestamentHeader = {
    id: 'header',
    src: require('./images/oldtestament/1230_elements_Genesis.png')
  };
  christianButtons = [
    {
      id: 'christianEducation',
      to: '/spiritual/christian/christian_education',
      highlight: require('./images/christian/Christian_Education_HL.png'),
      unhighlight: require('./images/christian/Christian_Education_UH.png'),
      desc: require('./images/christian/Christian_Education_desc.png'),
      alt: 'Christian Education'
    },
    {
      id: 'christianInspiration',
      to: '/spiritual/christian/christian_inspiration',
      highlight: require('./images/christian/Christian_Inspiration_HL.png'),
      unhighlight: require('./images/christian/Christian_Inspiration_UH.png'),
      desc: require('./images/christian/Christian_Inspiration_desc.png'),
      alt: 'Christian Inspiration'
    },
    {
      id: 'prayers',
      to: '/spiritual/christian/prayers',
      highlight: require('./images/christian/Christian_Prayers_HL.png'),
      unhighlight: require('./images/christian/Christian_Prayers_UH.png'),
      desc: require('./images/christian/Christian_Prayers_desc.png'),
      alt: 'Prayers'
    },
    {
      id: 'sacred',
      to: '/spiritual/christian/sacred',
      highlight: require('./images/christian/Christian_Sacred_HL.png'),
      unhighlight: require('./images/christian/Christian_Sacred_UH.png'),
      desc: require('./images/christian/Christian_Sacred_desc.png'),
      alt: 'Sacred'
    }
  ];
  testamentButtons = [
    {
      id: 'oldTestament',
      to: '/spiritual/christian/christian_education/old_testament',
      highlight: require('./images/education/OldTestament_HL.png'),
      unhighlight: require('./images/education/OldTestament_UH.png'),
      desc: require('./images/education/OldTestament_desc.png'),
      alt: 'Old Testament'
    },
    {
      id: 'newTestament',
      to: '/spiritual/christian/christian_education/new_testament',
      highlight: require('./images/education/NewTestament_HL.png'),
      unhighlight: require('./images/education/NewTestament_UH.png'),
      desc: require('./images/education/NewTestament_desc.png'),
      alt: 'New Testament'
    }
  ];
  genesisButton = [
    {
      id: 'genesis',
      to: '/spiritual/christian/christian_education/old_testament/genesis',
      highlight: require('../common/images/empty.png'),
      unhighlight: require('../common/images/empty.png'),
      desc: require('../common/images/empty.png'),
      alt: 'Genesis'
    }
  ];

  playingButton = [
    {
      id: 'playing',
      to: '/spiritual/christian/christian_education/old_testament/genesis/playing',
      highlight: require('../common/images/empty.png'),
      unhighlight: require('../common/images/empty.png'),
      desc: require('../common/images/empty.png'),
      alt: 'Genesis'
    }
  ];

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="spiritual-1230">
        <Switch>
          <Route path="/spiritual/christian/christian_education/new_testament"
                 render={() => <Redirect to="/spiritual/christian/christian_education/old_testament" />} />
          <Route path="/spiritual/christian/christian_inspiration"
                 render={() => <Redirect to="/spiritual/christian/christian_education" />} />
          <Route path="/spiritual/christian/prayers" render={() => <Redirect to="/spiritual/christian/christian_education" />} />
          <Route path="/spiritual/christian/sacred" render={() => <Redirect to="/spiritual/christian/christian_education" />} />
          <Route path="/spiritual/general" render={() => <Redirect to="/spiritual/christian" />} />
          <Route path="/spiritual/islam" render={() => <Redirect to="/spiritual/christian" />} />
          <Route path="/spiritual/judaism" render={() => <Redirect to="/spiritual/christian" />} />
          <Route
            path="/spiritual/christian/christian_education/old_testament/genesis/playing"
            render={routeProps => (
              <MusicOptions
                {...routeProps}
                header={this.oldTestamentHeader}
                banner={this.bannerVisible}
                text={this.nowPlayingGenesis}
                navigationBar={this.genesisNavigationBar}
                imageButtonsList={this.spiritualButtonList}
                imageButtons={this.genesisButton}
              />
            )}
          />
          <Route
            path="/spiritual/christian/christian_education/old_testament/genesis"
            render={routeProps => (
              <SpiritualMusic
                {...routeProps}
                header={this.oldTestamentHeader}
                banner={this.bannerVisible}
                text={this.selectCategory}
                popup={this.chapterPopup}
                navigationBar={this.genesisNavigationBar}
                imageButtonsList={this.spiritualButtonList}
                imageButtons={this.playingButton}
              />
            )}
          />
          <Route
            path="/spiritual/christian/christian_education/old_testament"
            render={routeProps => (
              <MusicOptions
                {...routeProps}
                header={this.oldTestamentHeader}
                banner={this.bannerVisible}
                text={this.selectCategory}
                navigationBar={this.christianEducationNavigationBar}
                imageButtonsList={this.spiritualButtonList}
                imageButtons={this.genesisButton}
              />
            )}
          />
          <Route
            path="/spiritual/christian/christian_education"
            render={routeProps => (
              <MusicOptions
                {...routeProps}
                header={this.christianHeader}
                banner={this.bannerVisible}
                text={this.selectListen}
                navigationBar={this.educationNavigationBar}
                imageButtonsList={this.spiritualButtonList}
                imageButtons={this.testamentButtons}
              />
            )}
          />
          <Route
            path="/spiritual/christian"
            render={routeProps => (
              <MusicOptions
                {...routeProps}
                header={this.christianHeader}
                banner={this.bannerVisible}
                text={this.selectCategory}
                navigationBar={this.christianNavigationBar}
                imageButtonsList={this.spiritualButtonList}
                imageButtons={this.christianButtons}
              />
            )}
          />
          <Route
            path="/spiritual"
            render={routeProps => (
              <MusicOptions
                {...routeProps}
                header={this.spiritualHeader}
                banner={this.bannerVisible}
                text={this.selectReligious}
                navigationBar={this.spiritualNavigationBar}
                imageButtonsList={this.spiritualButtonList}
                imageButtons={this.musicButtons}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}
